import React from "react";
import { AuthProvider } from "./subContexts/AuthContext";
import { DataProvider } from "./subContexts/DataContext";
import { UIProvider } from "./subContexts/UIContext";

const RootProvider = ({ children }) => {
  

  return (
    <DataProvider>
      <AuthProvider>
        <UIProvider>{children}</UIProvider>
      </AuthProvider>
    </DataProvider>
  );
};

export default RootProvider;
